import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-pagination', 'title', 'Pagination navigation');
Labels.set('ui-pagination', 'previousPage', 'Previous page');
Labels.set('ui-pagination', 'nextPage', 'Next page');
Labels.set('ui-pagination', 'currentPage', 'Current page');
Labels.set('ui-pagination', 'page', 'Page');
Labels.set('ui-pagination', 'show', 'Show per page');
